export default __webpack_public_path__ + "static/media/lupa.86384f75.png";